// This enum is for Profile Media Response GQL endpoint, example use of this in IRepresentativesEditProfile.ts
export enum MediaFileType {
  IMAGE = 'image',
  VIDEO = 'video',
  AUDIO = 'audio',
  DOCUMENT = 'document',
}
